import styled, { css } from "styled-components";

export const GameBadgeFlipperWrapper = styled.div <{ useSquareIcons?: boolean; }>`
    position: absolute;
    left: 0;

    background-color: transparent;
    perspective: 1000px;
    
    ${props => props.useSquareIcons ? css`
        bottom: 0;
        width: 33%;
        height: 27%;
        
        max-width: 49px;
        max-height: 55px;
        ` : css`
        height: 24%;
        top: 0;
        width: 23%;
    `}
`;
